import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Název',
    field: 'label',
    type: ColumnType.TEXT,
    width: '100px'
  }
];



// WEBPACK FOOTER //
// ./src/modules/roles-create/_rolesCreateNewColumns.ts